<template>
  <div>
    <view-table
        ref="vmTable"
        url="materialLabelPrints/page"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        :table-select="false"
        module="basic"
        @reset="handleReset"
        @delete="handleDelete"
        @addOrEdit="handleAddOrEdit">
      <template #adSearch>
        <el-form :inline="true" :model="filter" @keyup.enter.native="getList(1)">
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="模板名称">
            <el-input v-model.trim="filter.templateName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户">
            <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <material-label-print-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import MaterialLabelPrintEdit from "@/views/MaterialLabel/MaterialLabelPrintEdit.vue";
  import ViewTable from "@/components/ViewTable.vue";

  export default {
    name: "MaterialLabelPrintList",
    components: {ViewTable, MaterialLabelPrintEdit},
    data() {
      return {
        limits: {
          delAuth: this.$auth(725),
          editAuth: this.$auth(724),
          addAuth: this.$auth(723),
        },
        filter: {
          materialNo: "",
          templateName: "",
          customerName: "",
        },
        columnsProperty: [
          {
            key: "action",
            width: 150,
            slot: "action",
            align: "center",
          },
        ],
      };
    },
    mounted() {
      // this.getList(1);
    },
    methods: {
      getList(num) {
        this.$refs.vmTable.loadData(num);
      },
      handleReset(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      handleAddOrEdit(row) {
        if (row) {
          this.$refs.editPage.open(row.id);
        } else {
          this.$refs.editPage.open();
        }
      },
      handleDelete(row) {
        this.$http.delete("basic","materialLabelPrints",row.id).then(() => {
          this.getList(-1);
          this.$message.success("删除成功");
        });
      },
    },
  };
</script>

<style scoped>

</style>
